module.exports = __webpack_public_path__ + "static/media/logo-freshsales.dfa6baad.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo-freshsales.png
// module id = 1301
// module chunks = 17